import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home'
  },
  {
    path: '/merchantAssistant',
    name: 'merchantAssistant',
    component: () =>
      import('@/views/merchantAssistant.vue')
  },
  {
    path: '/inspirationCenter',
    name: 'inspirationCenter',
    component: () =>
      import('@/views/inspirationCenter.vue')
  },
  {
    path: '/xdkAi',
    name: 'xdkAi',
    component: () =>
      import('@/views/coze.vue')
  },
  {
    path: '/cozeIndex',
    name: 'cozeIndex',
    component: () =>
      import('@/views/cozeIndex.vue')
  },
  // {
  //   path: '/homes',
  //   name: 'homes',
  //   component: () => import('@/views/ProductItem.vue')
  // },
  {
          path: '/home',
          name: 'home',
          component: () => import('@/views/ProductItem.vue')
        },
        {
          path: '/price',
          name: 'price',
          component: () => import('@/views/ListPrice.vue')
        },
        {
          path: '/computeRecharge',
          name: 'computeRecharge',
          component: () => import('@/views/ComputeRecharge.vue')
        },
        {
          path: '/AccountSettings',
          name: 'AccountSettings',
          component: () =>
            import('@/views/AccountSettings.vue')
        },
        {
          path: '/recommendCenter',
          name: 'recommendCenter',
          component: () =>
            import('@/views/recommendCenter.vue')
        },
        {
          path: '/login',
          name: 'login',
          component: () =>
            import('@/views/login.vue')
        },
        {
          path: '/wechatAuth',
          name: 'wechatAuth',
          component: () =>
            import('@/views/wechatAuth.vue')
        },
 
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: () => import('@/views/index.vue'),
  //   children: [{
  //       path: 'ProductItem',
  //       name: 'ProductItem',
  //       component: () => import('@/views/ProductItem.vue')
  //     },
  //     {
  //       path: 'ListPrice',
  //       name: 'ListPrice',
  //       component: () => import('@/views/ListPrice.vue')
  //     },
  //     {
  //       path: 'AccountSettings',
  //       name: 'AccountSettings',
  //       component: () =>
  //         import('@/views/AccountSettings.vue')
  //     },

  //     {
  //       path: 'login',
  //       name: 'login',
  //       component: () =>
  //         import('@/views/login.vue')
  //     },
  //     {
  //       path: 'wechatAuth',
  //       name: 'wechatAuth',
  //       component: () =>
  //         import('@/views/wechatAuth.vue')
  //     },
  //   ]
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js